export default "__VITE_ASSET__BDWHkcdS__"